module.exports = __webpack_public_path__ + "img/Meal voucher Icon - white.df26a730.svg";